import { select, call } from 'redux-saga/effects';
import { get } from 'lodash';
import { API } from '../../api';

const getServerConfig = ({ serverConfig }) => serverConfig;
const getIsPublic = ({ isPublic }) => isPublic;

export function* deleteLayerCache({ serverConfig, key }) {
  try {
    const path = `/delete-layer-cache/${serverConfig.namespace}/${key}`;
    yield call(API, 'get', 'api', path);
    return;
  } catch (e) {
    console.error('Error deleting layer cache', e);
    return;
  }
}

export function* deleteLayer(action) {
  const isPublic = yield select(getIsPublic);
  if (isPublic) return;
  const serverConfig = yield select(getServerConfig);

  const key = get(action, 'payload.key');
  const path = `/layer/${serverConfig.namespace}/${key}`;
  yield call(deleteLayerCache, { serverConfig, key });
  yield call(API, 'del', 'api', path);
}
